'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowBackOutline = function TiArrowBackOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.9 32.6c-2.7-4.2-6.1-5.5-10.2-5.8v2.4c0 0.9-0.4 1.7-1 2.3-1.3 1.3-3.5 1.3-4.7 0l-10.5-10.3c-0.3-0.3-0.5-0.8-0.5-1.2s0.2-0.9 0.5-1.2l10.5-10.3c1.2-1.3 3.4-1.3 4.7 0 0.6 0.6 1 1.4 1 2.3v2.9c7.7 1.5 13.3 8.3 13.3 16.3v1.7c0 0.7-0.5 1.4-1.2 1.6-0.1 0-0.3 0-0.5 0-0.5 0-1-0.2-1.4-0.7z m-11.9-9.2c3.7 0 7.8 0.6 11.3 3.5-1.3-5.4-5.8-9.5-11.5-10.1-0.8-0.1-1.5-0.1-1.5-0.1v-5.9l-9.3 9.2 9.3 9.2v-5.9s1.3 0.1 1.7 0.1z' })
        )
    );
};

exports.default = TiArrowBackOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-back-outline.js
// module id = 1944
// module chunks = 0